<div class="modal">
    <div>
        <h4 class="titleModal" [class.warning]="warning" [class.warning-amber]="warningAmber">{{message}}</h4>
    </div>
    <div class="btnModal">
        <button class="mini-button annulla" (click)="close()">{{cancelLabel}}</button>
        <button class="mini-button conferma" (click)="save()">{{confirmLabel}}</button>
    </div>
</div>